<template>
    <multi-select
        ref="optionList"
        :placeholder="placeholder"
        :options="options"
        label="label"
        track-by="value"
        :internal-search="asyncSearch"
        :show-labels="false"
        :preserve-search="true"
        :close-on-select="false"
        :hide-selected="true"
        :value="selectedOptions"
        :multiple="true"
        @search-change="asyncFind"
        @input="updateFilter"
        @close="closeEvent"
        :loading="isLoading">
        <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag" v-fs-block>
                        <span>{{ formatSelectedTag(props.option.value) }}</span>
                        <i aria-hidden="true" tabindex="1"
                           @keydown.enter.prevent="props.remove(props.option)"
                           @mousedown.prevent="props.remove(props.option)"
                           class="multiselect__tag-icon"></i>
                    </span>
        </template>
        <template slot="noResult">
            <span>No results match your search query.</span>
        </template>
        <template slot="noOptions">
            <span>All available {{itemKeyword}} have been selected.</span>
        </template>
    </multi-select>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    import truncate from '@/common/helpers/truncate';
    import pluralize from '@/common/helpers/pluralize';

    export default {
        name: 'search-select',
        components: {MultiSelect},
        props: {
            item: Object,
        },
        data() {
            return {
                selectedOptions: [],
                options: [],
                isLoading: false,
                recentlyClosed: false,
            };
        },
        computed: {
            filterOptions() {
                return this.item.config.options;
            },
            asyncSearch() {
                return this.item.config.options.options.source !== 'rebillyAPI';
            },
            placeholder() {
                return this.item.config ? `Select ${this.item.config.label}` : 'Select Option';
            },
            itemKeyword() {
                return this.item.config ? pluralize(this.item.config.label, 2) : 'options';
            },
        },
        watch: {
            'item.values': function refresh() {
                this.restoreSelection();
            },
        },
        methods: {
            getSelectedValues() {
                return this.selectedOptions && this.selectedOptions.length
                    ? this.selectedOptions.map(option => option.value)
                    : [];
            },
            closeEvent() {
                this.updateFilter();
                this.recentlyClosed = true;
            },
            updateFilter(data) {
                if (data !== undefined) {
                    this.selectedOptions = Array.isArray(data) ? data : null;
                }
                this.$emit('update', this.getSelectedValues());
            },
            restoreSelection() {
                if (Array.isArray(this.item.values)) {
                    this.selectedOptions = this.item.values.map(item => ({
                        value: item,
                        label: item,
                    }));
                }
            },
            async asyncFind(query) {
                this.isLoading = true;
                try {
                    const options = await this.filterOptions.getAll(query);
                    this.options = options
                        .filter(({label, value}) => !!(label && value));
                    if (!this.recentlyClosed && this.item.isNewlyAdded) {
                        // prevent the activation if the query was reset after the menu was closed
                        this.item.setIsDirty();
                        this.$refs.optionList.activate();
                    } else {
                        this.recentlyClosed = false;
                    }
                } catch (error) {
                    this.$toast.fromError(error, 'Unable to find the information that was requested.');
                    this.options = [];
                } finally {
                    this.isLoading = false;
                }
            },
            formatSelectedTag(value) {
                return truncate(value, {
                    limit: 11,
                    dots: true,
                });
            },
        },
        mounted() {
            this.restoreSelection();
            this.asyncFind();
        },
    };
</script>
